<template>
  <div class="teamApply">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="110px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label-width="80" label="企业名称">
          <el-input
            clearable
            v-model.trim="formInline.name"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsName" label="联系人名称">
          <el-input
            clearable
            v-model.trim="formInline.contactsName"
            placeholder="请输入联系人名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsPhone" label="联系人手机号">
          <el-input
            v-model.trim="formInline.contactsPhone"
            maxlength="11"
            placeholder="请输入联系人手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title">
        <el-button size="small" type="primary" @click="handleIntroduce"
          >合作项目介绍</el-button
        >
        <el-button size="small" type="primary" @click="handleExport"
          >导出</el-button
        >
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="序号" width="80" align="center" type="index">
        </el-table-column>
        <el-table-column label="单位名称" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsPhone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合作意愿" minWidth="220" align="center">
          <template slot-scope="{ row }">
            <span>{{
              handleCooperateDesire(row.cooperateDesire, row.otherDesire)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkAdmin()"
          label="所属代理商"
          minWidth="160"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.targetCompamnyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代理商合作意见" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.proxyAuditState === 1"
              >合作</el-tag
            >
            <el-tag type="danger" v-else-if="row.proxyAuditState === 2"
              >不合作</el-tag
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!checkAdmin()"
          label="剩余处理天数"
          minWidth="190"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="!row.proxyAuditState">{{ handleSurplusTime(row.insertDate) }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.remarks || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="handleDetail(row)">详情</span>
            <a
              href="javascript:;"
              :disabled="!row.proxyRejectNum"
              @click="openAuditFailReason(row)"
              >拒绝合作原因</a
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <IntroduceDialog
      v-if="introduceDialogFlag"
      :handleClose="handleCloseIntroduceDialog"
    />

    <FileExport ref="FileExport" />

    <HandleAgency ref="handleAgencyRef" />
    <!-- 审核驳回原因 -->
    <AuditFailReason ref="auditFailReasonRef" />
  </div>
</template>

<script>
import { getCooperationApplyListPage } from "@/api/organization";
import FileExport from "@/components/FileExport.vue";
import AuditFailReason from "@/views/organization/components/auditFailReason.vue";
import IntroduceDialog from "@/views/organization/components/introduceDialog.vue";
import HandleAgency from "@/views/organization/components/handleAgency.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "TeamApply",
  components: {
    myPagination,
    FileExport,
    IntroduceDialog,
    HandleAgency,
    AuditFailReason,
  },
  data() {
    return {
      loading: false,
      intendList: [
        {
          label: "全媒体运营师培训+考核",
          value: "6",
        },
        {
          label: "网络视听主播培训+考核",
          value: "7",
        },
        {
          label: "其他",
          value: "8",
        },
      ],
      formInline: {
        name: "",
        contactsName: "",
        contactsPhone: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      currentTime: "",
      introduceDialogFlag: false,
    };
  },
  mounted() {
    this.getCooperationApplyListPage({ page: 1, limit: 10 });
  },
  methods: {
    // 处理剩余天数
    handleSurplusTime(payload) {
      if (!payload) return "--";
      let time = new Date(payload).getTime();
      let byTime = 86400000 * 30 + time;
      let surplusTime = (byTime - this.currentTime) / 1000;
      if (surplusTime <= 0) return "--";
      let t = parseInt(surplusTime / 60 / 60 / 24);
      return `${t}天`;
    },
    // 审核驳回原因
    openAuditFailReason(payload) {
      let status = '1'
      this.$refs.auditFailReasonRef.init(status, payload.licenseNum);
    },
    handleCooperateDesire(payload, otherDesire = '') {
      if (!payload) {
        return "--";
      }
      let arr = payload.split(",");
      let newArr = arr.map((item) => {
        return this.cooperateDesireFn(item, otherDesire);
      });
      return newArr.join(",");
    },
    cooperateDesireFn(payload, otherDesire) {
      if (payload === "3") {
        return otherDesire;
      }
      let brr = this.intendList.find((item) => {
        return item.value === payload;
      });
      return brr ? brr.label : '';
    },
    // 详情
    handleDetail(payload) {
      this.$refs.handleAgencyRef.init("distribution_details", payload);
    },
    // 合作项目介绍
    handleIntroduce() {
      this.introduceDialogFlag = true;
    },
    handleCloseIntroduceDialog(projectContent) {
      if (projectContent && projectContent !== "<p><br></p>") {
        this.$confirm(
          "此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?",
          "提示",
          {
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.introduceDialogFlag = false;
        });
      } else {
        this.introduceDialogFlag = false;
      }
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        this.searchData, // 搜索表单参数
        "jsw-base-provider", // 后端对应业务线服务
        "/adm/cooperationApply/export", // 导出-对应的接口
        1, //  状态：0get、1post
        "合作申请.xlsx" //文件名称
      );
    },
    // 刷新
    refresh() {
      this.getCooperationApplyListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getCooperationApplyListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getCooperationApplyListPage({ ...payload });
      this.currentTime = res.timestamp;
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getCooperationApplyListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getCooperationApplyListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getCooperationApplyListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getCooperationApplyListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.teamApply {
  .title {
    margin: 0px 0 10px;
  }

  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
